import React from "react";
import Spinner from "react-bootstrap/Spinner";
import Typography from "../../../../../../../components/typography/Typography";

const LLMSummarySidebarLoader = () => (
  <div
    className={
      "d-flex flex-column justify-content-center align-items-center gap-20 w-100 vh-75 text-center"
    }
  >
    <Spinner animation="border" variant="primary" />
    <Typography
      variant={"body6"}
      className={"text-color-light-gray"}
      tag={"span"}
    >
      Generating AI summary. This may take a few moments.
    </Typography>
  </div>
);

export default LLMSummarySidebarLoader;
